import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PREMISSIONS } from '../enums/permissions';
import { TabItem } from '../interfaces/tab-item.interface';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class TabRoutesService {
  private tabRoutes = new BehaviorSubject([] as TabItem[]);

  tabRotues$ = this.tabRoutes.asObservable();

  updateList(newList: TabItem[]) {
    this.tabRoutes.next(newList.filter((el) => this.isAllowed(el.premission)));
  }

  smsMessages: TabItem[] = [
    {
      title: 'SMS.GENERAL.ADD_SMS_MESSAGES',
      link: 'create-sms-message',
      premission: PREMISSIONS.SMSMessage.Create,
    },
    {
      title: 'SMS.GENERAL.LIST_SMS_MESSAGES',
      link: 'sms-messages',
      premission: PREMISSIONS.SMSMessage.View,
    },
  ];

  smsTemplates: TabItem[] = [
    {
      title: 'SMS_TEMPLATE.GENERAL.ADD_SMS_TEMPLATE',
      link: 'create-sms-template',
      premission: PREMISSIONS.ScheduleTemplate.Create,
    },
    {
      title: 'SMS_TEMPLATE.GENERAL.VIEW_SMS_TEMPLATES',
      link: 'list-sms-templates',
      premission: PREMISSIONS.ScheduleTemplate.View,
    },
  ];

  senders: TabItem[] = [
    {
      title: 'SMS_SENDERS.GENERAL.ADD_SMS_SENDERS',
      link: 'create-sender',
      premission: PREMISSIONS.SMSMessage.Create,
    },
    {
      title: 'SMS_SENDERS.GENERAL.VIEW_SMS_SENDERS',
      link: 'list-senders',
      premission: PREMISSIONS.SMSMessage.View,
    },
  ];

  smsProviders: TabItem[] = [
    {
      title: 'SMS_PROVIDER.GENERAL.VIEW_SMS_PROVIDERS',
      link: 'list-sms-providers',
      premission: PREMISSIONS.SMSMessage.View,
    },
    {
      title: 'SMS_PROVIDER.GENERAL.ADD_SMS_PROVIDER',
      link: 'create-sms-provider',
      premission: PREMISSIONS.SMSMessage.Create,
    },
  ];

  accountCategory: TabItem[] = [
    {
      title: 'ACCOUNTCATE.GENERAL.ADD_ACCOUNTCATE',
      link: 'create-or-update-account-category',
      premission: PREMISSIONS.GlAccountCategory.Create,
    },
    {
      title: 'ACCOUNTCATE.GENERAL.VIEW_ACCOUNTCATE',
      link: 'list-account-category',
      premission: PREMISSIONS.GlAccountCategory.View,
    },
  ];

  //Account Type
  accountType: TabItem[] = [
    {
      title: 'ACCOUNTTYPE.GENERAL.ADD_ACCOUNTTYPE',
      link: 'create-or-update-account-type',
      premission: PREMISSIONS.GlAccountType.Create,
    },
    {
      title: 'ACCOUNTTYPE.GENERAL.VIEW_ACCOUNTTYPE',
      link: 'list-account-type',
      premission: PREMISSIONS.GlAccountType.View,
    },
  ];

  //Chart of Accounts
  chartAccounts: TabItem[] = [
    {
      title: 'ACCOUNTING.GENERAL.CHARTACC',
      link: 'list-accounts',
      premission: PREMISSIONS.GLAccount.View,
    },
  ];

  //Journal
  journals: TabItem[] = [
    {
      title: 'DAILYJOURNAL.GENERAL.ADD_JOURNAL',
      link: 'create-or-update-journal',
      premission: PREMISSIONS.Journal.Create,
    },
    {
      title: 'DAILYJOURNAL.GENERAL.VIEW_JOURNAL',
      link: 'list-journals',
      premission: PREMISSIONS.Journal.View,
    },
  ];

  //Voucher
  vouchers: TabItem[] = [
    {
      title: 'RECEIPT_VOUCHER.GENERAL.ADD_RECEIPT_VOUCHER',
      link: 'create-or-update-receipt-voucher',
      premission: PREMISSIONS.ReceiptVoucher.Create,
    },
    {
      title: 'RECEIPT_VOUCHER.GENERAL.VIEW_RECEIPT_VOUCHER',
      link: 'list-receipt-vouchers',
      premission: PREMISSIONS.ReceiptVoucher.View,
    },
  ];

  paymentVouchers: TabItem[] = [
    {
      title: 'PAYMENT_VOUCHER.GENERAL.ADD_PAYMENT_VOUCHER',
      link: 'create-or-update-payment-voucher',
      premission: PREMISSIONS.PaymentVoucher.Create,
    },
    {
      title: 'PAYMENT_VOUCHER.GENERAL.VIEW_PAYMENT_VOUCHER',
      link: 'list-payment-vouchers',
      premission: PREMISSIONS.PaymentVoucher.View,
    },
  ];

  //Journal
  openBalance: TabItem[] = [
    {
      title: 'OPEN_BALANCE.GENERAL.ADD_BALANCE',
      link: 'create-open-balance/create/new',
      premission: PREMISSIONS.OpeningBalance.UpSert,
    },
    {
      title: 'OPEN_BALANCE.GENERAL.OPEN_BALANCES',
      link: 'list-open-balances',
      premission: PREMISSIONS.OpeningBalance.View,
    },
  ];

  //Account Statements
  account_statements: TabItem[] = [
    {
      title: 'ACCOUNTSTAT.GENERAL.VIEW_ACCOUNTSTAT',
      link: 'list-account-statements',
      premission: PREMISSIONS.AccountStatement.View,
    },
  ];
  //Financial Statements
  financial_statements: TabItem[] = [
    {
      title: 'FINANCIALSTAT.GENERAL.ADD_FINANCIALSTAT',
      link: 'create-or-update-financial-statement',
      premission: PREMISSIONS.FinancialStatementItem.Create,
    },
    {
      title: 'FINANCIALSTAT.GENERAL.VIEW_FINANCIALSTAT',
      link: 'list-financial-statement',
      premission: PREMISSIONS.FinancialStatementItem.View,
    },
  ];

  branches: TabItem[] = [
    {
      title: 'BRANCHES.BTN.CREATE',
      link: 'branch/branch/create/new',
      premission: PREMISSIONS.Branch.Create,
      activeStateLinks: ['branch/branch/'],
    },
    {
      title: 'BRANCHES.GENERAL.VIEW_BRANCHES',
      link: 'branch/branches-list',
      premission: PREMISSIONS.Branch.View,
    },
  ];

  //Journal Type
  journalType: TabItem[] = [
    {
      title: 'JOURNALTYPE.GENERAL.ADD_JOURNALTYPE',
      link: 'create-or-update-journal-type',
      premission: PREMISSIONS.JournalTypes.Create,
    },
    {
      title: 'JOURNALTYPE.GENERAL.VIEW_JOURNALTYPE',
      link: 'list-journal-type',
      premission: PREMISSIONS.JournalTypes.View,
    },
  ];

  //TAX RETURN
  taxReturn: TabItem[] = [
    {
      title: 'TAXRETURN.GENERAL.TITLE',
      link: 'tax-return',
      premission: PREMISSIONS.TaxReturn.View,
    },
  ];

  //zatca unit
  zatcaUnit: TabItem[] = [
    {
      title: 'ZATCAUNIT.GENERAL.ZATCAUNIT',
      link: 'zatcaUnit',
      activeStateLinks: ['zatcaUnit/'],
      premission: PREMISSIONS.ZatcaUnits.Create,
    },
    {
      title: 'ZATCAUNIT.GENERAL.ZATCALIST',
      link: 'zatcaUnits',
      premission: PREMISSIONS.ZatcaUnits.View,
    },
  ];
  //ElectronicInvoice
  electronicInv: TabItem[] = [
    {
      title: 'ELECTRONICINV.GENERAL.ELECINV',
      link: 'electronicInv',
      premission: PREMISSIONS.Document.ZATCA.View,
    },
  ];

  salesInvoice: TabItem[] = [
    {
      title: 'INVOICES.GENERAL.ADD_INVOICE_SALES',
      link: 'create-invoice/create/new',
      premission: [
        PREMISSIONS.Document.Sales.Create,
        PREMISSIONS.Document.Sales.Update,
      ],
    },
    {
      title: 'INVOICES.GENERAL.VIEW_SALES_INVOCES',
      link: 'sales-invoices/invoice',
      premission: PREMISSIONS.Document.Sales.View,
    },
  ];

  quotations: TabItem[] = [
    {
      title: 'QUOTATION.GENERAL.ADD_QUOTATION',
      link: 'create-quotation',
      premission: [
        PREMISSIONS.OfferPrice.Create,
        PREMISSIONS.OfferPrice.Update,
      ],
    },
    {
      title: 'QUOTATION.GENERAL.QUOTATION_TITLE',
      link: 'list',
      premission: PREMISSIONS.OfferPrice.View,
    },
  ];

  salesOrders: TabItem[] = [
    {
      title: 'SALES_ORDER.BTN.ADD_NEW',
      link: 'create-sales-order',
      premission: [
        PREMISSIONS.SalesOrders.Create,
        PREMISSIONS.SalesOrders.Update,
      ],
    },
    {
      title: 'SALES_ORDER.GENERAL.VIEW_LIST',
      link: 'list-sales-orders',
      premission: PREMISSIONS.SalesOrders.View,
    },
  ];

  deliveryNotes: TabItem[] = [
    {
      title: 'DELIVERY_NOTE.BTN.ADD_NEW',
      link: 'create-delivery-note',
      premission: [
        PREMISSIONS.DeliveryNotes.Create,
        PREMISSIONS.DeliveryNotes.Update,
      ],
    },
    {
      title: 'DELIVERY_NOTE.GENERAL.VIEW_LIST',
      link: 'list-delivery-note',
      premission: PREMISSIONS.DeliveryNotes.View,
    },
  ];

  purchasesInvoice: TabItem[] = [
    {
      title: 'INVOICES.GENERAL.ADD_INVOICE_PURCHASES',
      link: 'create-invoice/create/new',
      premission: PREMISSIONS.Document.Purches.Create,
    },
    {
      title: 'INVOICES.GENERAL.VIEW_PURCHASE_INVOCES',
      link: 'purchases-invoices/invoice',
      premission: PREMISSIONS.Document.Purches.View,
    },
  ];

  returnPurchseInvoices: TabItem[] = [
    {
      title: 'INVOICES.GENERAL.ADD_INVOICE_PURCHASES_RETURN',
      link: 'create-return-invoice/new',
      premission: PREMISSIONS.Document.PurchesReturn.Create,
    },
    {
      title: 'INVOICES.GENERAL.VIEW_PURCHASE_RETURN_INVOCES',
      link: 'return-invoices',
      premission: PREMISSIONS.Document.PurchesReturn.View,
    },
  ];

  purchaseOrders: TabItem[] = [
    {
      title: 'PURCHASE_ORDER.BTN.ADD_NEW',
      link: 'create-purchase-order',
      premission: PREMISSIONS.PurchaseOrders.Create,
    },
    {
      title: 'PURCHASE_ORDER.GENERAL.VIEW_LIST',
      link: 'list-purchase-orders',
      premission: PREMISSIONS.PurchaseOrders.View,
    },
  ];

  goodsReceipts: TabItem[] = [
    {
      title: 'GOODS_RECEIPT.BTN.ADD_NEW',
      link: 'create-goods-receipt',
      premission: PREMISSIONS.GoodsReceipts.Create,
    },
    {
      title: 'GOODS_RECEIPT.GENERAL.VIEW_LIST',
      link: 'list-goods-receipts',
      premission: PREMISSIONS.GoodsReceipts.View,
    },
  ];

  purchaseRequisitions: TabItem[] = [
    {
      title: 'PURCHASE_REQUISITION.BTN.ADD_NEW',
      link: 'create-purchase-requisition',
      premission: PREMISSIONS.PurchaseRequisitions.Create,
    },
    {
      title: 'PURCHASE_REQUISITION.GENERAL.VIEW_LIST',
      link: 'list-purchase-requisitions',
      premission: PREMISSIONS.PurchaseRequisitions.View,
    },
  ];

  posInvoices: TabItem[] = [
    {
      title: 'SALESSCREEN.TITLE.CREATE_INVOICE',
      link: 'create-invoice/create/new',
      premission: PREMISSIONS.POSTerminals.Create,
    },
    {
      title: 'INVOICES.GENERAL.VIEW_POS_SALES',
      link: 'list-invoices',
      premission: PREMISSIONS.POSTerminals.View,
    },
    {
      title: 'INVOICES.GENERAL.VIEW_POS_RETURNS',
      link: 'list-return-invoices',
      premission: PREMISSIONS.POSTerminals.View,
    },
    {
      title: 'INVOICES.GENERAL.PENDING_INVOICES',
      link: 'pending-invoices',
      premission: PREMISSIONS.POSTerminals.View,
    },
  ];

  companies: TabItem[] = [
    // {
    //   title: 'COMPANIES.GENERAL.TITLE',
    //   link: 'companies',
    // },
    {
      title: 'COMPANIES.BTN.CREATE',
      link: 'company',
      premission: PREMISSIONS.Company.Create,
    },
  ];

  currencies: TabItem[] = [
    {
      title: 'CURRENCIES.BTN.CREATE',
      link: 'currency',
      premission: PREMISSIONS.Currencies.Create,
    },
    {
      title: 'CURRENCIES.GENERAL.TITLE',
      link: 'currencies',
      premission: PREMISSIONS.Currencies.View,
    },
  ];
  //Tax Category Tabs
  taxCategory: TabItem[] = [
    {
      title: 'TAXCATE.GENERAL.TITLE',
      link: 'taxCategory/create/new',
      premission: PREMISSIONS.TaxCategory.Create,
    },
    {
      title: 'TAXCATE.GENERAL.TAX_CATES',
      link: 'taxCategories',
      premission: PREMISSIONS.TaxCategory.View,
    },
  ];

  roles: TabItem[] = [
    {
      title: 'SIDEMENU.ROLE',
      link: 'role',
      premission: PREMISSIONS.Roles.View,
    },
    {
      title: 'ROLES.BTN.CREATE',
      link: 'roles',
      premission: PREMISSIONS.Roles.Create,
    },
  ];

  customers: TabItem[] = [
    {
      title: 'CUSTOMERS.BTN.ADDITEM',
      link: 'create-customer',
      premission: PREMISSIONS.Customer.Create,
    },
    {
      title: 'CUSTOMERS.GENERAL.TITLE',
      link: 'customers-list',
      premission: PREMISSIONS.Customer.View,
    },
  ];

  vendors: TabItem[] = [
    {
      title: 'CUSTOMERS.BTN.ADDVENDOR',
      link: 'create-vendor',
      premission: PREMISSIONS.Vendor.Create,
    },
    {
      title: 'CUSTOMERS.GENERAL.TITLE_VENDOR',
      link: 'vendors-list',
      premission: PREMISSIONS.Vendor.View,
    },
  ];

  //Products Routing Tab
  products: TabItem[] = [
    {
      title: 'PRODUCTS.GENERAL.TITLE',
      link: 'list-products',
      premission: PREMISSIONS.Products.View,
    },
    {
      title: 'PRODUCTS.GENERAL.CREATE_PRODUCT',
      link: 'create-or-update-product/create/new',
      premission: PREMISSIONS.Products.Create,
    },
    {
      title: 'PRODUCTS.GENERAL.SETTINGS_PRODUCT',
      link: 'settings-products',
      premission: PREMISSIONS.Products.Create,
    },

    // {
    //   title: 'SIDEMENU.PRODUCT_CATE',
    //   link: 'list-categories',
    // },
    // {
    //   title: 'UNITS_OF_MEASUREMENT.GENERAL.TITLE',
    //   link: 'list-units',
    // },
    // {
    //   title: 'BARCODE.GENERAL.TITLE',
    //   link: 'list-barcode',
    // },
  ];

  //Product Category Routing Tab
  productCategory: TabItem[] = [
    {
      title: 'PRODUCTCATE.BTN.ADDITEM',
      link: 'create-update-product-category',
      premission: PREMISSIONS.ProductGroup.Create,
    },
    {
      title: 'PRODUCTCATE.GENERAL.TITLE',
      link: 'list-product-category',
      premission: PREMISSIONS.ProductGroup.View,
    },
  ];
  //Stors Tab
  stores: TabItem[] = [
    {
      title: 'STORE.GENERAL.ADD_STORE',
      link: 'create-update-store',
      premission: PREMISSIONS.Unit.Create,
    },
    {
      title: 'STORE.GENERAL.VIEW_STORES',
      link: 'list-store',
      premission: PREMISSIONS.Unit.View,
    },
  ];

  users: TabItem[] = [
    {
      title: 'USERS.GENERAL.ADD_USER',
      link: 'create-user',
      premission: PREMISSIONS.Users.Create,
    },
    {
      title: 'USERS.GENERAL.TITLE',
      link: 'users-list',
      premission: PREMISSIONS.Users.View,
    },
  ];

  units: TabItem[] = [
    {
      title: 'UNITS.BTN.ADDITEM',
      link: 'create-update-unit',
      premission: PREMISSIONS.Unit.Create,
    },
    {
      title: 'UNITS.GENERAL.TITLE',
      link: 'list-product-units',
      premission: PREMISSIONS.Unit.View,
    },
  ];

  prices: TabItem[] = [
    {
      title: 'PRICES.BTNS.ADDITEM',
      link: 'create-update-price',
      premission: PREMISSIONS.PriceLevel.Create,
    },
    {
      title: 'PRICES.GENERAL.TITLE',
      link: 'list-prices',
      premission: PREMISSIONS.PriceLevel.View,
    },
  ];

  // Manual Inventory Tabs
  manualInventory: TabItem[] = [
    {
      title: 'MANAUL_INVEOTRY.BTN.ADDITEM',
      link: 'create-manaul-inventory',
      premission: PREMISSIONS.ManualInventory.Create,
    },
    {
      title: 'MANAUL_INVEOTRY.GENERAL.VIEW_MANUAL',
      link: 'list-manual-inventories',
      premission: PREMISSIONS.ManualInventory.View,
    },
  ];

  openingStock: TabItem[] = [
    {
      title: 'OPENING_STOCK.BTN.ADDITEM',
      link: 'create-opening-stock/create/new',
      premission: PREMISSIONS.OpeningStock.Create,
    },
    {
      title: 'OPENING_STOCK.GENERAL.VIEW_OPENING',
      link: 'list-opening-stocks',
      premission: PREMISSIONS.OpeningStock.View,
    },
  ];

  branchesTransfer: TabItem[] = [
    {
      title: 'BRANCHES_TRANSFER.BTN.ADD_NEW',
      link: 'create-branches-transfer',
      premission: PREMISSIONS.BranchesTransfer.Create,
    },
    {
      title: 'BRANCHES_TRANSFER.GENERAL.VIEW_TRANSFER',
      link: 'list-branches-transfer',
      premission: PREMISSIONS.BranchesTransfer.View,
    },
  ];

  warehousesTransfer: TabItem[] = [
    {
      title: 'WAREHOUSES_TRANSFER.BTN.ADD_NEW',
      link: 'create-warehouses-transfer',
      premission: PREMISSIONS.WarehousesTransfer.Create,
    },
    {
      title: 'WAREHOUSES_TRANSFER.GENERAL.VIEW_TRANSFER',
      link: 'list-warehouses-transfer',
      premission: PREMISSIONS.WarehousesTransfer.View,
    },
  ];

  warehouseIssueOrder: TabItem[] = [
    {
      title: 'WAREHOUSE_ISSUE_ORDER.BTN.ADD_NEW',
      link: 'create-warehouse-issue-order',
      premission: PREMISSIONS.WarehouseIssueOrder.Create,
    },
    {
      title: 'WAREHOUSE_ISSUE_ORDER.GENERAL.VIEW_ISSUE_ORDER',
      link: 'list-warehouse-issue-order',
      premission: PREMISSIONS.WarehouseIssueOrder.View,
    },
  ];

  warehouseSupplyOrder: TabItem[] = [
    {
      title: 'WAREHOUSE_SUPPLY_ORDER.BTN.ADD_NEW',
      link: 'create-warehouse-supply-order',
      premission: PREMISSIONS.WarehouseSupplyOrder.Create,
    },
    {
      title: 'WAREHOUSE_SUPPLY_ORDER.GENERAL.VIEW_SUPPLY_ORDER',
      link: 'list-warehouse-supply-order',
      premission: PREMISSIONS.WarehouseSupplyOrder.View,
    },
  ];

  fiscalYears: TabItem[] = [
    {
      title: 'FINANCIALYEAR.TAB.ADD_FINANCIAL_YEAR',
      link: 'financial-year/create/new',
      premission: PREMISSIONS.FinancialYear.Create,
    },
    {
      title: 'FINANCIALYEAR.TAB.VIEW_FINANCIAL_YEARS',
      link: 'list',
      premission: PREMISSIONS.FinancialYear.View,
    },
    // {
    //   title: 'FINANCIALYEAR.TAB.AUDIT_LOG',
    //   link: 'audit-log',
    // },
  ];

  shiftCategories: TabItem[] = [
    {
      title: 'SHIFT_CATEGORIES.GENERAL.CREATE_SHIFT_CATEGORY',
      link: 'create-update-shift-category/create/new',
      premission: PREMISSIONS.ShiftCategory.Create,
      activeStateLinks: ['create-update-shift-category/'],
    },
    {
      title: 'SHIFT_CATEGORIES.GENERAL.SHIFT_CATEGORIES',
      link: 'list-shift-categories',
      premission: PREMISSIONS.ShiftCategory.View,
    },
  ];

  private isAllowed(permission?: string | string[]): boolean {
    if (!permission) return true;
    if (Array.isArray(permission)) {
      return permission.some((p) => this.perm.hasPermission(p));
    }
    return this.perm.hasPermission(permission);
  }

  systemSettings: TabItem[] = [
    // {
    //   title: 'SYSTEM_SETTINGS.TABS.CURRENCY',
    //   link: 'currency',
    //   premission: PREMISSIONS.GeneralSettings.View
    // },
    // {
    //   title: 'SYSTEM_SETTINGS.TABS.LANGUAGE',
    //   link: 'language',
    //   premission: PREMISSIONS.GeneralSettings.View
    // },
    // {
    //   title: 'SYSTEM_SETTINGS.TABS.DATE_CALENDAR',
    //   link: 'date-calendar',
    //   premission: PREMISSIONS.GeneralSettings.View
    // },
    {
      title: 'SYSTEM_SETTINGS.TABS.ROUNDING',
      link: 'general-settings/rounding',
      premission: PREMISSIONS.GeneralSettings.View,
    },
    {
      title: 'SYSTEM_SETTINGS.TABS.NUMBERING',
      link: 'general-settings/numbering',
      premission: PREMISSIONS.GeneralSettings.View,
    },
    {
      title: 'SYSTEM_SETTINGS.TABS.SYSTEM_SHORTCUTS',
      link: 'general-settings/system-shortcuts',
      premission: PREMISSIONS.GeneralSettings.View,
    },
    {
      title: 'SYSTEM_SETTINGS.TABS.SALES_POLICY',
      link: 'general-settings/sales-policy',
      premission: PREMISSIONS.GeneralSettings.View,
    },
    {
      title: 'SYSTEM_SETTINGS.TABS.POS_SETTINGS',
      link: 'general-settings/pos-settings',
      premission: PREMISSIONS.GeneralSettings.View,
    },
    // {
    //   title: 'SYSTEM_SETTINGS.TABS.AUDIT',
    //   link: 'audit',
    //   premission: PREMISSIONS.GeneralSettings.View
    // }
  ];

  constructor(private perm: PermissionService) {}
}
